import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SearchFilterModel } from '@app/search/components/model/search-filter.model';

@Component({
  templateUrl: './search-filter-item.component.html',
  styleUrls: ['search-filter-item.component.scss'],
  selector: 'search-filter-item',
})
export class SearchFilterItemComponent implements OnInit {

  @Input() filter: SearchFilterModel;
  @Input() type: 'selected' | 'suggested';
  @Output() selected = new EventEmitter<SearchFilterModel>();
  @Output() removed = new EventEmitter<SearchFilterModel>();

  constructor(
  ) {
  }

  ngOnInit() {
  }

  onSelectFilter() {
    this.selected.emit(this.filter);
  }

  onRemoveFilter() {
    this.removed.emit(this.filter);
  }
}
